import { render, staticRenderFns } from "./RecordKeeper.vue?vue&type=template&id=74877f81&"
import script from "./RecordKeeper.vue?vue&type=script&lang=js&"
export * from "./RecordKeeper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports